// ═══════════════════════════════════════════════════════════════════════════
// La barra de «estás viendo como»
//
// Existe por una razón concreta: quien entra en la piel de otro para revisar
// una pantalla se distrae, y diez minutos después está trabajando de verdad
// creyendo que es él mismo. Todo lo que haga queda firmado —la bitácora guarda
// quién actuó de verdad— pero eso lo arregla después, no en el momento.
//
// Así que la barra es fija, va arriba de todo, y no se puede cerrar. Es la
// única pieza de la interfaz que se permite estorbar a propósito.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { viendoComo, volverASerYo } from "../auth/suplantar.js";

export function BarraSuplantacion({ onVolvi }) {
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");
  const quien = viendoComo();
  if (!quien) return null;

  const volver = async () => {
    setOcupado(true); setError("");
    try {
      await volverASerYo();
      onVolvi?.();
    } catch (e) { setError(e.message); setOcupado(false); }
  };

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 900,
                  background: "#3a2a08", borderBottom: "1px solid #6a5010",
                  padding: "8px 14px", display: "flex", alignItems: "center",
                  gap: 12, flexWrap: "wrap" }}>
      <span style={{ fontSize: 12, color: "#facc15" }}>
        👁 Estás viendo la app como <b>{quien.nombre}</b>
        {quien.role ? <span style={{ color: "#a89050" }}> · {quien.role}</span> : null}
      </span>
      <span style={{ fontSize: 11, color: "#a89050", flex: 1, minWidth: 140 }}>
        Lo que hagas queda registrado a tu nombre.
      </span>
      {error && <span style={{ fontSize: 11, color: "#f87171" }}>{error}</span>}
      <button onClick={volver} disabled={ocupado}
        style={{ fontSize: 12, padding: "6px 14px", borderRadius: 6, cursor: "pointer",
                 fontFamily: "inherit", background: "#1a1408",
                 border: "1px solid #6a5010", color: "#facc15",
                 opacity: ocupado ? 0.5 : 1 }}>
        {ocupado ? "Volviendo…" : "Volver a ser yo"}
      </button>
    </div>
  );
}
